export default __webpack_public_path__ + "static/logopedie-ten-bos-10f2edbb7344bf04995a3999f04109d8.png";